<div class="web-analytics">
    <div id="web-analytics-chart"></div>
</div>